module.exports = __webpack_public_path__ + "static/media/compete.df9c2969.gif";